import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ClientNavbar from "./ClientNavbar";
import ClientNavbar2 from "./ClientNavbar2";
import ClientNavbar1 from "./ClientNavbar1";
import { Icon } from '@iconify/react';
import { useAuth } from "../../Context/UserContext";
import { url } from '../../constants/url';
import { toast } from 'react-toastify';

const OpenVulnerabilities = () => {
    const { isSidebarCollapsed, emailVer, logout } = useAuth();

    const [vulnerabilities, setVulnerabilities] = useState([])
    const [searchQuery, setSearchQuery] = useState("");
    const [inputFocused, setInputFocused] = useState(false);

    const [vulnerabilityId, setVulnerabilityId] = useState('');

    const handleSearchInput = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleAccept = async (id) => {
        try {

            const response = await fetch(`${url}/acceptvulnerability?vulnerabilityId=${id}`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: 'include'
            })

            if (response.status === 200) {
                fetchDeveloperVulnerability()
                toast.success('Vulnerability Accepted...', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }

            if (response.status === 404) {
                toast.error('Vulnerability not found...', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }

        } catch (error) {
            console.log(error)
        }
    }


    const fetchDeveloperVulnerability = async () => {
        try {
            const response = await fetch(`${url}/developeropenvulnerabilities`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
            })

            const data = await response.json()

            const sortedVulnerability = data.sort((a, b) => {
                const statusOrder = ["unassigned", "inprogress", "reopen", "closed"]; // lowercase
                const statusA = (a.bugStatus || '').toLowerCase();
                const statusB = (b.bugStatus || '').toLowerCase();

                return statusOrder.indexOf(statusA) - statusOrder.indexOf(statusB);
            });


            setVulnerabilities(sortedVulnerability);

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchDeveloperVulnerability()
         if (emailVer.endsWith("@isecurion.com")) {
            logout();
            return;
        }
    }, [])

    const filteredVulnerabilities = vulnerabilities.filter((vul) => {
        const matchesSearch =
            (vul.vulnerabilityName || "")
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
            (vul.bugStatus || "")
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
            (vul.severity || "")
                .toLowerCase()
                .includes(searchQuery.toLowerCase())


        return matchesSearch;
    });


    return (
        <div className="client-openVulnerability-dash">
            <div>
                <div className='client_navabr1'>
                    <ClientNavbar1 />
                </div>
                <div className='navbar_second'><ClientNavbar2 /></div>
            </div>
            <div className='wrap_navbar_dashboard'>
                <div className={isSidebarCollapsed ? 'clientdash-navbar' : 'clientdash_close_navbar'}>
                    <ClientNavbar />
                </div>
                <div className="project-table-container">
                    <div className="project-table-header-container">
                        <div className="project-table-header-content">
                            <h2 className="project-table-header">View and manage all ongoing and completed vulnerabilities
                            </h2>
                            <div className="project-table-search-input" style={{
                                padding: '5px 6px',
                            }}>
                                <Icon icon="ic:round-search" width="20" height="20" style={{ color: "#E76A34", marginRight: "8px" }} />
                                <input
                                    className="search-input"
                                    type="text"
                                    placeholder="Search Vulnerabilities..."
                                    onChange={handleSearchInput}
                                    value={searchQuery}
                                    onFocus={() => setInputFocused(true)}
                                    onBlur={() => setInputFocused(false)}
                                />
                            </div>
                        </div>

                        <div className="project-table-main-container" style={{marginTop:"20px"}}>
                            <table>
                                <thead className="project-table-main-container-header">
                                    <tr>
                                        <th>Vuln ID</th>
                                        <th>Vulnerability</th>
                                        <th>Severity</th>
                                        <th><Icon icon="fluent:status-20-regular" width="16" height="16" />Assigned By</th>
                                        <th><Icon icon="hugeicons:time-quarter-02" width="16" height="16" />Timeline to Fix</th>
                                        <th><Icon icon="fluent:phone-status-bar-20-regular" width="16" height="16" />Vuln Status</th>
                                        <th><Icon icon="fluent:phone-status-bar-20-regular" width="16" height="16" />Retest Status</th>
                                    </tr>
                                </thead>
                                <tbody className="project-table-main-container-body">
                                    {filteredVulnerabilities.length === 0 ? (
                                        <tr className="collapsetable">
                                            <td colSpan="7">Vulnerabilities Not Found....</td>
                                        </tr>
                                    ) : (
                                        vulnerabilities && vulnerabilities.map((vul, index) => {
                                            const dueDate = new Date(vul.dueDate);
                                            const today = new Date();
                                            const diffTime = dueDate - today;
                                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{vul.vulnerabilityName}</td>
                                                    <td className="vulnerabilities" >
                                                        <span className={`severity status-${vul.severity.toLowerCase().replace(/\s/g, '')}`}>{vul.severity}</span>
                                                    </td>

                                                    <td>
                                                        <span className='profile-icon'>
                                                            {vul.assignedBy && vul.assignedBy.charAt(0).toUpperCase()}
                                                        </span>
                                                        {vul.assignedBy}
                                                    </td>
                                                    <td>
                                                        {vul.bugStatus === "Closed"
                                                            ? "-"
                                                            : isNaN(diffDays)
                                                                ? "N/A"
                                                                : diffDays > 0
                                                                    ? `${diffDays} day(s)`
                                                                    : "Due today or overdue"}
                                                    </td>

                                                    <td>
                                                        {vul.bugStatus === 'Open' ? (
                                                            <span
                                                                className={`status-badge status-${vul.bugStatus.toLowerCase().replace(/\s/g, '')} vlu-status`}
                                                                onClick={() => handleAccept(vul._id)}>
                                                                Accept
                                                            </span>
                                                        ) : (
                                                            <span className={`status-badge status-${vul.bugStatus.toLowerCase().replace(/\s/g, '')}`}>
                                                                {vul.bugStatus === 'Inprogress' ? 'In Progress' : vul.bugStatus}
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>{vul.retestStatus}</td>
                                                </tr>
                                            );
                                        })

                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OpenVulnerabilities